import {Button, Col, Row} from "reactstrap";
import {ChangeDateFormat} from "../../Common/Helpers/ChangeDateFormat";
import {useTranslation} from "react-i18next";
import {CheckUserRole} from "../../AppSystem/Helpers/CheckUserRole";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import useApiCallService from "../../Common/Helpers/ApiCall";

export function SwedbankReportView({data, modelId = null}) {
    const { t } = useTranslation();
    const isSuperAdmin = CheckUserRole('SuperAdmin');
    const { ApiCall } = useApiCallService();

    const handleDownloadApiResponse  = (response, name) => {
        
        let file;
        if (response instanceof Blob) {
          file = response;
          
        } else {
          file = new Blob([response]);
        }
        let fileName = name;

        if (!name || name.trim() === "") {
            fileName = "file.pdf";
        } else {
            fileName = name;
        }
        
        const urlToFile = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = urlToFile;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
    }

    const DownloadFile = async (id, fileName) => {
        let url = `/file?id=${id}`        
        const apiCallOptions = {
            method: "get",
            url: url,
            dataTypes: 'blob',
            responseType: 'blob'
        };
        try {
            await ApiCall(apiCallOptions, (response) => handleDownloadApiResponse(response, fileName));

        } catch (error) {
            console.log(error);
        }
    };
    return (
        <Row className="px-4 justify-content-center">
            <Col lg={8}>
                <h2 className="rokkitt-font">{t('sidebar.swedbankReport')}</h2>
            </Col>
            <Col lg={4} >
                <ul className="list-unstyled">
                    {isSuperAdmin === true && modelId ?
                        <>
                            <li className="pt-1 row">
                                <span className="fw-bold col-4">{t('modelLabel.modelId')}:</span>
                                <span className="col-8">{modelId}</span>

                            </li>
                        </>
                        : '' }
                </ul>
            </Col>
            <Col lg={10} className="border-top">
                <Row>
                    {isSuperAdmin === true ?
                        <Col lg={6}>
                                <ul className="list-unstyled">
                                    <li className="pt-2 row">
                                        <span className="fw-bold col-4">{t('modelLabel.id')} </span>
                                        <span className="col-8">{data.id}</span>
                                    </li>                                 
                                </ul>
                        </Col>
                    : ''}
                    <Col lg={6}>
                        <ul className="list-unstyled">
                            {data.visualId !== "" ?
                                <li className="pt-2 row">
                                    <span className="fw-bold col-4">{t('modelLabel.id')}:</span>
                                    <span className="col-8">{data.visualId}</span>
                                </li>
                            : ""}
                            <li className="pt-2 row">
                                <span className="fw-bold col-4">{t('modelLabel.createdAt')} </span>
                                <span className="col-8">{ChangeDateFormat('dateTime', data.createdAt)}</span>

                            </li>
                        </ul>
                    </Col>
                </Row>
            </Col>
            <Col lg={10} className="border-bottom">
                <Row>
                    <Col lg={6}>
                        <ul className="list-unstyled">
                            <li className="pt-2 row">
                                        <span className="fw-bold col-4">{t('swedbankReport.redovisningsnummer')} </span>
                                        <span className="col-8">{data.accountingNumber}</span>
                                    </li>
                            {/* <li className="pt-2 row">
                                <span className="fw-bold col-4">{t('reimbursement.amount')} </span>
                                <span className="col-8">{data.amountPaidOut ? ToCustomDecimal(data.amountPaidOut) : 0} kr</span>

                            </li> */}
                            <li className="pt-2 row">
                                <span className="fw-bold col-4">{t('reimbursement.amount')} </span>
                                <span className="col-8">{data.amount ? ToCustomDecimal(data.amount) : 0} kr</span>

                            </li>
                            {/* {data.vat ?
                                <li className="pt-2 row">
                                    <span className="fw-bold col-4">{t('modelLabel.vatAmount')} </span>
                                    <span className="col-8">{data.vat ? ToCustomDecimal(data.vat) : 0} kr</span>

                                </li>
                                : ''}
                            {data.fee ?
                                <li className="pt-2 row">
                                    <span className="fw-bold col-4">{t('modelLabel.feeAmount')} </span>
                                    <span className="col-8">{data.fee ? ToCustomDecimal(data.fee) : 0} kr</span>

                                </li>
                                : ''} */}

                            {data.reportingDate ?
                                <li className="pt-2 row">
                                    <span className="fw-bold col-4">{t('swedbankReport.redovisningsdatum')} </span>
                                    <span className="col-8">{ChangeDateFormat('dateTime', data.reportingDate)}</span>

                                </li>
                            : ''}
                            {data.totalTransactions ?
                                <li className="pt-2 row">
                                    <span className="fw-bold col-4">{t('swedbankReport.totalTransactions')} </span>
                                    <span className="col-8">{data.totalTransactions}</span>

                                </li>
                            : ''}
                        </ul>
                    </Col>
                    <Col lg={6} className="order-1 order-lg-0 d-flex  align-items-end justify-content-end  gap-3 pt-3 pt-lg-0 pb-2">
                        {data?.fileId && (
                            <Button 
                                className="bg-green-light text-green border-0 position-relative ms-2" 
                                onClick={() => {
                                    DownloadFile(data.fileId, data.fileName);
                                }}
                            >
                                <i className="bx bx-down-arrow-alt fs-5 align-middle pb-1" />
                                <span className="ms-2">PDF-fil </span>
                                <div className="tooltip-custom-button-table">
                                    Ladda ner Swedbank PDF-fil
                                </div>
                            </Button>
                        )} 
                        {data?.fileXslxId && (
                            <Button 
                                className="bg-green-light text-green border-0 position-relative" 
                                onClick={() => {
                                    DownloadFile(data.fileXslxId, data.fileXslxName);
                                }}
                            >
                                <i className="bx bx-down-arrow-alt fs-5 align-middle pb-1" />
                                <span className="ms-2">XSLM-fil</span>
                                <div className="tooltip-custom-button-table">
                                    Ladda ner Swedbank XSLM-fil
                                </div>
                            </Button>
                        )} 
                        {data?.fileXmlId && (
                            <Button 
                                className="bg-green-light text-green border-0 position-relative" 
                                onClick={() => {
                                    DownloadFile(data.fileXmlId, data.fileXmlName);
                                }}
                            >
                                <i className="bx bx-down-arrow-alt fs-5 align-middle pb-1" />
                                <span className="ms-2">XML-fil</span>
                                <div className="tooltip-custom-button-table">
                                    Ladda ner Swedbank XML-fil
                                </div>
                            </Button>
                        )} 
                            
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}